
document.querySelectorAll( '.b-data-brokers-search' ).forEach( ( block ) => {

	const input = block.querySelector( '.js-filterSearch_input' );
	const groups = block.querySelectorAll( '.js-filterSearch_list' );

	if ( !input || !groups.length ) {

		return;

	}

	let timer = null;
	const DEBOUNCE_DELAY = 250;
	const sites = block.querySelector( '.js-filterSearch_sites' );

	/**
	 * Filter items based on input value
	 */
	const filter = () => {

		const query = input.value.trim().toLowerCase();

		if ( sites ) {

			sites.classList.toggle( 'is-searching', query.length > 0 );

		}

		groups.forEach( ( group ) => {

			const items = group.querySelectorAll( '.js-filterSearch_item' );

			items.forEach( ( item ) => {

				const text = item.textContent.toLowerCase();
				const isMatch = text.includes( query );

				item.classList.toggle( 'is-hidden', !isMatch );

			} );

			const visibleItems = group.querySelectorAll( '.js-filterSearch_item:not(.is-hidden)' );

			group.classList.toggle( 'is-hidden', visibleItems.length === 0 );

		} );

	};

	/**
	 * Handle input with debounce
	 */
	const handleInput = () => {

		clearTimeout( timer );
		timer = setTimeout( filter, DEBOUNCE_DELAY );

	};

	input.addEventListener( 'input', handleInput );

	// Optional: initial run (e.g. prefilled input)
	filter();

} );
